import { AnalyticsService } from '@analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { OfferStatus, OfferType } from '@dgx-pr-spa/shared/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { planType } from '@shared/helpers/function.helpers';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as fromGA from '../actions';

const GenerateCommonElements = (offer) => {
  return {
    event: 'PRGenericGAEvent',
    clientName: 'DG PR',
    genericpagename: 'product-replacement-offer',
    category: 'product-replacement',
    pagename: 'product-replacement-before-you-start',

    OfferType: 'Standard',
    AccountBrand: offer.current_item.make,
    Manufacturer: offer.current_item.make,
    planNumber: offer.current_plan.plan_number,
    productName: `${offer.current_item.make} ${offer.current_item.appliance_category}`,
    productModel: offer.current_item.model,
    applianceName: offer.current_item.appliance_category,
    customerType: 'G',
    PRFreeOffers: offer.replacement_offers.filter(
      (i) => i.offer_type === OfferType.REPLACEMENT
    ).length,
    PRUpgradeOffers: offer.replacement_offers.filter(
      (i) => i.offer_type === OfferType.UPGRADE
    ).length,
    JobReferenceNumber: offer.current_plan.reference_number,
    customerID: offer.contact_details.person_gid,
    PlanType: planType(offer.current_plan),
    NumberOfItems: offer.replacement_offers.length,
    PRGroup: 'aws',
    upsell_flag: offer.offer.upsell_flag,
    PRStarted: 1,
  };
};

@Injectable()
export class GATipsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly analyticsService: AnalyticsService,
    private readonly viewOffersService: ViewOffersService
  ) {}

  AccordionOpened$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGA.AccordionOpen),
        map((action) => action.title),
        withLatestFrom(this.viewOffersService.offers$),
        tap(([title, offer]) => {
          this.analyticsService.eventEmitter({
            ...GenerateCommonElements(offer),
            eventPR: 'pr-new-landing-accordions',
            eventCategory: 'Product Replacement',
            eventAction: 'PR open accordions - new landing',
            eventLabel: title,
          });
        })
      ),
    {
      dispatch: false,
    }
  );

  PageLoad$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGA.TipPageLoad),
        switchMap(() => this.viewOffersService.offersLoaded$),
        filter((loaded) => loaded),
        withLatestFrom(this.viewOffersService.offers$),
        filter(([, offer]) => {
          return offer.offer.offer_status !== OfferStatus.TAKEN;
        }),
        tap(([, offer]) => {
          this.analyticsService.eventEmitter({
            ...GenerateCommonElements(offer),
            event: 'PRAWS',
            eventPR: 'pr-new-landing',
          });
        })
      ),
    { dispatch: false }
  );

  BrowseNewProducts$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromGA.BrowseNewProducts),
        map((action) => action.label),
        withLatestFrom(this.viewOffersService.offers$),

        tap(([label, offer]) => {
          this.analyticsService.eventEmitter({
            ...GenerateCommonElements(offer),
            eventPR: 'pr-new-landing-accordions',
            eventCategory: 'Product Replacement',
            eventAction: 'CTA clicks - new landing',
            eventLabel: label,
          });
        })
      ),
    { dispatch: false }
  );
}
